import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('saved_views_board_column_settings');
	},
};
